import { Action, createReducer, on } from '@ngrx/store';
import { loadNewUserPasscodes, loadNewUserPasscodesSuccess, loadNewUserPasscodesFailure } from '../actions/new-user-passcode.actions';
import { INewUserPasscodeRequest, INewUserPasscodeSuccess } from '../models/new-user-passcode.model';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';

export const newUserPasscodeFeatureKey = 'newUserPasscode';

export interface NewUserPasscodeState {
  isLoading: boolean;
  loadNewUserPasscodes: INewUserPasscodeRequest;
  loadNewUserPasscodesSuccess: INewUserPasscodeSuccess;
  loadNewUserPasscodesFailure: IGenericError<ErrorResponse>;
}

export const initialState: NewUserPasscodeState = {
  isLoading: false,
  loadNewUserPasscodes: undefined,
  loadNewUserPasscodesFailure: undefined,
  loadNewUserPasscodesSuccess: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadNewUserPasscodes, (state, action) => ({
    ...state,
    loadNewUserPasscodes: action.request,
    isLoading: true
  })),
  on(loadNewUserPasscodesSuccess, (state, action) => ({
    ...state,
    loadNewUserPasscodesSuccess: action.response,
    isLoading: false
  })),
  on(loadNewUserPasscodesFailure, (state, action) => ({
    ...state,
    loadNewUserPasscodesFailure: action.error,
    isLoading: false
  }))
);

export const getNewUserPasscodesRequest = (state: NewUserPasscodeState) => state.loadNewUserPasscodes;
export const getNewUserPasscodesResponse = (state: NewUserPasscodeState) => state.loadNewUserPasscodesSuccess;
export const getNewUserPasscodesFailure = (state: NewUserPasscodeState) => state.loadNewUserPasscodesFailure;
export const getNewUserPasscodesIsLoading = (state: NewUserPasscodeState) => state.isLoading;
